import { Box, Button, CircularProgress } from '@mui/material';

interface PaymentBtnProps {
  handleDeleteInvoice: () => void;
  handleSubmitPayment: () => void;
  isLoading: boolean;
}

interface RefundBtnProps {
  handleRefundInvoice: () => void;
  handlePrintInvoice: () => void;
  isLoading: boolean;
}

interface OverDueButtonProps {
  handlePrintInvoice: () => void;
  handleAddPayment: () => void;
}

// type RefundedBtn = Omit<RefundBtnProps, handl>
export const PaymentAndDeleteButton: React.FC<PaymentBtnProps> = ({
  handleDeleteInvoice,
  handleSubmitPayment,
  isLoading,
}) => (
  <>
    <Box>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Button
          type="submit"
          variant="contained"
          disableElevation
          onClick={handleDeleteInvoice}
          sx={{
            backgroundColor: '#C53B20',
            borderRadius: 2,
            '&:hover': {
              backgroundColor: '#db771a',
            },
          }}
        >
          Delete
        </Button>
      )}
    </Box>
    <Box>
      <Button
        type="submit"
        variant="contained"
        disableElevation
        sx={{ borderRadius: 2, mt: 3 }}
        onClick={handleSubmitPayment}
      >
        Submit Payment
      </Button>
    </Box>
  </>
);

export const RefundAndPrintButton: React.FC<RefundBtnProps> = ({
  handleRefundInvoice,
  handlePrintInvoice,
  isLoading,
}) => (
  <>
    <Box>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Button
          type="submit"
          variant="contained"
          disableElevation
          onClick={handleRefundInvoice}
          sx={{
            backgroundColor: '#C53B20',
            borderRadius: 2,
            '&:hover': {
              backgroundColor: '#db771a',
            },
          }}
        >
          Refund
        </Button>
      )}
    </Box>
    <Box>
      <Button
        type="button"
        variant="contained"
        disableElevation
        sx={{ borderRadius: 2, mt: 3 }}
        onClick={handlePrintInvoice}
      >
        Print
      </Button>
    </Box>
  </>
);

export const RefundedButton: React.FC<
  Omit<RefundBtnProps, 'handleRefundInvoice' | 'isLoading'>
> = ({ handlePrintInvoice }) => (
  <Button
    type="button"
    variant="contained"
    disableElevation
    sx={{ borderRadius: 2 }}
    onClick={handlePrintInvoice}
  >
    Print
  </Button>
);

export const OverDueButton: React.FC<OverDueButtonProps> = ({
  handlePrintInvoice,
  handleAddPayment,
}) => (
  <>
    <Box>
      <Button
        type="submit"
        variant="contained"
        disableElevation
        sx={{ borderRadius: 2 }}
        onClick={handleAddPayment}
      >
        Add Payment
      </Button>
    </Box>

    <Box>
      <Button
        type="button"
        variant="contained"
        disableElevation
        sx={{ borderRadius: 2, mt: 3 }}
        onClick={handlePrintInvoice}
      >
        Print
      </Button>
    </Box>
  </>
);
